import { Color } from "@repo/app-types/constants/colors";
import {
  AutomationDeliveryProvider,
  type AutomationDeliveryProvider as AutomationDeliveryProviderType,
} from "@repo/app-types/entities/automation";
import { DateTime } from "luxon";
import type { FC } from "react";
import { Size } from "../helpers/helpers.js";
import { Pill } from "../Pills/pill.js";

/**
 * Display names for every supported delivery provider. The record stays
 * exhaustive as providers are added to the shared domain type.
 */
export const automationDeliveryProviderLabels: Record<
  AutomationDeliveryProviderType,
  string
> = {
  [AutomationDeliveryProvider.EMAIL]: "Email",
  [AutomationDeliveryProvider.SLACK]: "Slack",
  [AutomationDeliveryProvider.TEAMS]: "Microsoft Teams",
};

/** Formats a run timestamp for display, e.g. "Jun 12, 9:44 AM". */
export function formatRunTime(isoTimestamp: string): string {
  return DateTime.fromISO(isoTimestamp).toFormat("MMM d, h:mm a");
}

/**
 * Marks a run as a preview (manually triggered), not a scheduled run. The pill
 * never shrinks: its label doesn't wrap and it clips its overflow, so giving up
 * width next to a long title would cut the word in half rather than shorten it.
 */
export const AutomationRunPreviewPill: FC = () => (
  <Pill
    size={Size.SMALL}
    color={Color.Gray}
    label="Preview"
    className="shrink-0"
  />
);
